import { Component, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/shared/store/states/app.state';
import { clearCurrentUser } from 'src/app/shared/store/actions/user.actions';
import { isPublicRoute } from 'src/app/shared/helpers/public-route.helper';
import { isKioskModeEnabled } from 'src/app/shared/helpers/kiosk-mode.helper';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  @Input() isSlimMode: boolean = true;
  @Input() hideSubSideBar: boolean = true;
  @Input() hideSideBar: boolean = true;
  @Input() title1: string = '';
  @Input() title2: string = '';

  isPublicRoute = false;

  constructor(
    private router: Router,
    private store: Store<AppState>
  ) {
    if (isPublicRoute(this.router.url)) {
      this.isPublicRoute = true;
      this.store.dispatch(clearCurrentUser());
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = (event as NavigationEnd).urlAfterRedirects;
        this.isPublicRoute = isPublicRoute(url);
        if (isPublicRoute(url)) {
          this.store.dispatch(clearCurrentUser());
        }
      });
  }

  ngOnInit(): void {}

  get isKioskMode(): boolean {
    return isKioskModeEnabled();
  }
}
